module.exports = __webpack_public_path__ + "static/img/icon-6.7a466612.png";